import { render, staticRenderFns } from "./FactorsResult.vue?vue&type=template&id=358eb7bc&scoped=true&"
import script from "./FactorsResult.vue?vue&type=script&lang=js&"
export * from "./FactorsResult.vue?vue&type=script&lang=js&"
import style0 from "./FactorsResult.vue?vue&type=style&index=0&id=358eb7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358eb7bc",
  null
  
)

export default component.exports